import React, { useReducer, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Col, Row, Input } from "reactstrap";
import { defaultState, initialize, parseAlert } from "./store/store";
import { alertReducer } from "./store/reducer";
import { FormattedDate, FormattedTime } from "react-intl";
import style from "./Alert.module.scss";
import { NewPost, Summary, PostList } from "./Items/";
import { PersonType } from "../AlertSimple/Fields/types";
import ChildAlert from "./Items/ChildAlert/ChildAlert";
import { parseDate } from "../../../utils/dateUtils";

const Alert = ({ open, toggle, ...props }) => {
  const [state, dispatch] = useReducer(alertReducer, defaultState(), initialize(props));
  const { ui, alertEv, lockDate, hasLockDate, loadingUpdateDate, messageDisplay } = state;

  useEffect(() => {
    fetchAlertFull(alertEv.id);
  }, [alertEv.id]);

  // Sync incoming prop alert -> internal reducer so modal updates when store changes (WS_ALERTS)
  useEffect(() => {
    if (props.alert) {
      try {
        dispatch({ type: "ALERT_UPDATE", alert: parseAlert(props.alert) });
      } catch (e) {
        dispatch({ type: "ALERT_UPDATE", alert: props.alert });
      }
    }
  }, [props.alert]);

  const fetchAlertFull = (id) => {
    props.fetchs.alert({ id }, (r) => {
      if (ui.loadings.alert) {
        dispatch({ type: "UPDATE_LOADING", loadings: { alert: false } });
      }
      if (r && r.alertEvent) {
        dispatch({ type: "ALERT_UPDATE", alert: parseAlert(r.alertEvent) });
        dispatch({
          type: "CHANGE_FIELDS",
          fields: {
            hasLockDate: r.alertEvent.hasExpirationDate,
            lockDate: r.alertEvent.expirationDate,
          },
        });

        if (r.alertEvent.processes === "CheckList") {
          props.fetchs.accountPersonRelationship({ id: r.alertEvent.personId }, (r) => {
            if (r && r.relationship && r.relationship.length > 0) {
              dispatch({ type: "ALERT_UPDATE", alert: { accountsRelated: r.relationship } });
            }
          });

          props.fetchs.fetchAlertAntiClientDetails(
            { clientId: r.alertEvent.personId, listCheckId: r.alertEvent.refId },
            (r) => {
              if (r && r.details) {
                const details = r.details.split(";");
                dispatch({ type: "ALERT_UPDATE", alert: { antiClientDetails: details } });
              }
            }
          );

          props.fetchs.fetchPersonInfo({ personId: r.alertEvent.personId }, (r) => {
            if (r && r.personInfo) {
              dispatch({ type: "ALERT_UPDATE", alert: { personInfo: r.personInfo } });
            }
          });
        }
      }
    });
  };
  const getAllFiles = () => {
    if (alertEv.events == null) return [];
    let files = [];
    alertEv.events.forEach((e) => files.push(...e.files));
    return files;
  };

  const updateLockDate = (fields) => {
    dispatch({ type: "CHANGE_FIELDS", fields });
  };

  const sendLockDate = () => {
    dispatch({
      type: "CHANGE_FIELDS",
      fields: { loadingUpdateDate: true, messageDisplay: false },
    });
    props.callApi("UpdateAccountLockDate", { id: alertEv.id, date: lockDate }, (response, error) => {
      dispatch({
        type: "CHANGE_FIELDS",
        fields: { loadingUpdateDate: false, messageDisplay: true },
      });
    });
  };

  return (
    <Modal isOpen={open} className={style.modal}>
      <ModalHeader toggle={toggle} className={style.header} style={{ padding: "10px 15px" }}>
        <div>{alertEv.title}</div>
        <div>
          {alertEv.lastDayIncreaseDate &&
          alertEv.lastDayIncreaseDate !== "0000-00-00T00:00:00" &&
          alertEv.status !== "Closed" ? (
            (() => {
              const parsedDate = new Date(parseDate(alertEv.lastDayIncreaseDate));
              return !isNaN(parsedDate) && parsedDate.toDateString() === new Date().toDateString() ? (
                <i className="fa fa-check-circle text-success mr-2" aria-hidden="true"></i>
              ) : (
                <i
                  className="fa fa-times-circle text-danger mr-2"
                  aria-hidden="true"
                  title={`Last Day Increase Date: ${parsedDate.toLocaleDateString("es-ES")}`}
                ></i>
              );
            })()
          ) : (
            <i className="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
          )}
          <FormattedDate value={new Date(parseDate(alertEv.date))} />
        </div>
      </ModalHeader>
      <ModalBody className={style.body}>
        {ui.childAlert.open && (
          <ChildAlert
            childAlert={ui.childAlert.alert}
            dispatch={(a) => dispatch(a)}
            fetchs={{
              downloadFile: props.fetchs.downloadFile,
              alert: props.fetchs.alert,
            }}
          />
        )}
        {!ui.childAlert.open && (
          <React.Fragment>
            <Summary
              dispatch={(a) => dispatch(a)}
              antiClientDetails={alertEv.antiClientDetails}
              accountsRelated={alertEv.accountsRelated}
              loadingAlert={ui.loadings.alert}
              title={alertEv.title}
              description={alertEv.description}
              personType={alertEv.personType}
              typeAlias={alertEv.personType == PersonType.All ? alertEv.accountId : alertEv.personId}
              relateds={alertEv.relateds}
              alertId={alertEv.id}
              refId={alertEv.refId}
              reftag={alertEv.refTag}
              days={alertEv.days ? alertEv.days : 0}
              trigger={alertEv.trigger}
              status={alertEv.status}
              markFalseCoincidence={alertEv.falseCoincidenceListCheck}
              processes={alertEv.processes}
              role={props.user.role}
              dataRelated={alertEv.dataRelated}
              name={alertEv.name}
              files={getAllFiles()}
              requestClosure={alertEv.requestClosure}
              closedAccountDate={alertEv.closedAccountDate}
              closedAccount={alertEv.closedAccount}
              Link={props.link}
              personInfo={alertEv.personInfo}
              alert={alertEv}
              enabledAlertFeatures={props.enabledAlertFeatures}
              fetchs={{
                send: props.fetchs.send,
                fileTypes: props.fetchs.fileTypes,
                downloadFile: props.fetchs.downloadFile,
                downloadPdf: props.fetchs.downloadPdf,
                updateStatus: props.fetchs.updateStatus,
                falseCoincidenceCheckList: props.fetchs.falseCoincidenteCheckList,
                closeAccountAlert: props.fetchs.closeAccountAlert,
                clientInfo: props.fetchs.fetchPersonInfo,
                mergePeople: props.fetchs.mergePeople,
                getParameterValue: props.fetchs.getParameterValue,
                getAvailableAlertSteps: props.fetchs.getAvailableAlertSteps,
                sendToStep: props.fetchs.sendToStep,
                getAlertAllowedActions: props.fetchs.getAlertAllowedActions,
                confirmAlertChanges: props.fetchs.confirmAlertChanges,
                calculateCurrentFutureRiskScores: props.fetchs.calculateCurrentFutureRiskScores,
                getComplianceEventComments: props.fetchs.getComplianceEventComments,
                upsertComplianceEventComments: props.fetchs.upsertComplianceEventComments,
              }}
            />
            {hasLockDate ? (
              <div>
                <Row>
                  <Col lg={4} style={{ marginLeft: "10px" }}>
                    Account lock date:
                  </Col>
                  <Col lg={6}>
                    <Input
                      type="date"
                      value={lockDate}
                      onChange={(e) => updateLockDate({ lockDate: e.target.value })}
                    />
                  </Col>
                  <Col>
                    <Button onClick={() => sendLockDate()}>
                      {loadingUpdateDate ? (
                        <i class="fa fa-spinner fa-pulse fa-fw"></i>
                      ) : (
                        <i class="fa fa-check" aria-hidden="true"></i>
                      )}
                    </Button>
                  </Col>
                </Row>
                {messageDisplay ? (
                  <Row style={{ color: "green", marginLeft: "20px" }}>Date was successfully updated</Row>
                ) : (
                  <div></div>
                )}
              </div>
            ) : (
              <div></div>
            )}
            <NewPost
              dispatch={(a) => dispatch(a)}
              user={props.user}
              readonly={alertEv.status == "Closed"}
              alertId={alertEv.id}
              status={alertEv.status}
              processes={alertEv.processes}
              enabledAlertFeatures={props.enabledAlertFeatures}
              fetchs={{
                addToHistory: props.fetchs.addToHistory,
                updateStatus: props.fetchs.updateStatus,
                alert: fetchAlertFull,
                updateGrid: props.fetchs.updateGrid,
                uploadFile: props.fetchs.uploadFile,
              }}
            />
            <div className={style.posts}>
            <PostList
              loadingAlert={ui.loadings.alert}
              events={
                alertEv.events
                  ? [...alertEv.events].sort((a, b) => a.id - b.id)
                  : []
              }
              fetchs={{
                downloadFile: props.fetchs.downloadFile,
              }}
            />
          </div>
          </React.Fragment>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light btn" onClick={() => toggle()}>
          Close window
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default Alert;
